import {Typography, alpha} from '@mui/material'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import grey from '@mui/material/colors/grey'

export default function LoadingCircularElemCntr() {
  return (
    <Box display={'flex'} justifyContent={'center'} textAlign={'center'} alignItems={'center'}>
      <Box
        display={'flex'}
        flexDirection={'column'}
        alignContent={'center'}
        textAlign={'center'}
        alignItems={'center'}
      >
        <Box
          sx={{position: 'fixed', borderRadius: '4px', top: '45%', zIndex: 10000}}
          boxShadow='rgba(0, 0, 0, 0.56) 0px 10px 35px 2px'
          bgcolor={'#1a1a26'}
          p={5}
          m={3}
        >
          <CircularProgress
            variant={'indeterminate'}
            size={35}
            sx={{
              '& .MuiCircularProgress-circle': {
                bgcolor: grey[50],
                zIndex: 10001,
                color: `${alpha(grey[50], 0.9)}`,
              },
            }}
          />
          <Typography variant={'h6'} color={grey[50]}>
            ...loading
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}
